import React from 'react'

import CommonBBPSReport from '../../common/commonReportSection'


const breadCrumbsTitle = {
        id: "1",
        title_1: 'Reports',
        title_2:  'Subscription Reports',
      }

const SubscriptionReport = ()=> {
    return  <CommonBBPSReport breadCrumbsTitle={breadCrumbsTitle}/>
}

export default SubscriptionReport